import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/faq')({
  beforeLoad: () => {
    throw redirect({ to: '/faqs', replace: true });
  },
})
